import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NoRoleRoutingModule } from './no-role-routing.module';
import { DashboardComponent } from './dashboard/dashboard.component';
import { TuiSvgModule } from '@taiga-ui/core';

@NgModule({
  declarations: [DashboardComponent],
  imports: [CommonModule, NoRoleRoutingModule, TuiSvgModule],
})
export class NoRoleModule {}
